export const storeStandingOrders = (state, standingOrders) => {
  state.standingOrders = [...standingOrders];
};
